/**
 * Safely parse JSON from localStorage with fallback to default value.
 * Handles cases where the stored value is 'undefined', null, or invalid JSON.
 *
 * @param {string} key - The localStorage key to retrieve
 * @param {*} defaultValue - The default value to return if parsing fails
 * @returns {*} The parsed value or defaultValue
 */
export const safeGetStoredJSON = (key, defaultValue) => {
    try {
        const item = localStorage.getItem(key);
        if (item && item !== 'undefined' && item !== 'null') {
            return JSON.parse(item);
        }
    } catch (e) {
        // Invalid JSON, clean up the corrupted data
        localStorage.removeItem(key);
    }
    return defaultValue;
};
